const isZoomed = () => {
  return window.devicePixelRatio !== 1;
};

export default isZoomed;
